import React from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import {
  useProjectStatusesRetrieval,
  useRemoveProjectStatus,
} from "@planzone/view-models";
import { Props } from "./types";
import { Status } from "./status";
import { ProjectStatusCreation } from "./projectStatusCreation";
import styles from "./styles.scss";
import { Loader } from "./loader";

const sortOrder = {
  pz_candidate: -1,
  pz_open: -2,
  pz_waiting: -3,
};

function ProjectStatusesList(_: Props) {
  const { t } = useTranslation();
  const {
    isRequestPending,
    isRequestSuccess,
    isRequestFailure,
    statuses,
    retrieveProjectStatuses,
  } = useProjectStatusesRetrieval();
  const {
    isRequestPending: isRemoveProjectStatusRequestPending,
    removeProjectStatus,
  } = useRemoveProjectStatus();
  const sortedStatuses = statuses.sort(
    (current, next) =>
      (sortOrder[next.label as keyof typeof sortOrder] || -4) -
      (sortOrder[current.label as keyof typeof sortOrder] || -4),
  );

  React.useEffect(() => {
    !isRequestPending &&
      !isRequestSuccess &&
      !isRequestFailure &&
      retrieveProjectStatuses();
  }, []);

  return (
    <div className={styles.projectStatusesList}>
      <div className={styles.heading}>
        <h1 className={styles.title}>
          {t("utilityPage.projectPage.projectStatuses.title")}
        </h1>
        <p className={styles.subTitle}>
          {t("utilityPage.projectPage.projectStatuses.subTitle")}
        </p>
      </div>
      <div className={styles.statuses}>
        {isRequestPending ? (
          <Loader />
        ) : (
          <>
            {sortedStatuses
              .filter((status) => status.label !== "pz_closed")
              .map((status) => (
                <Status
                  key={status.uuid}
                  status={status}
                  remove={(status) =>
                    !isRemoveProjectStatusRequestPending &&
                    removeProjectStatus(status)
                  }
                />
              ))}
          </>
        )}
      </div>
      <ProjectStatusCreation />
      <div className={classNames(styles.statuses, styles.lastStatus)}>
        {sortedStatuses
          .filter((status) => status.label === "pz_closed")
          .map((status) => (
            <Status
              key={status.uuid}
              status={status}
              remove={(status) =>
                !isRemoveProjectStatusRequestPending &&
                removeProjectStatus(status)
              }
            />
          ))}
      </div>
    </div>
  );
}

export { ProjectStatusesList };
